import React, { useRef, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import dropIcon from "../../images/icon/dropdown_icon.svg";
import premiumIcon from "../../images/icon/premium_icon.svg";
import editIcon from "../../images/icon/edit_icon.svg";
import translateIcon from "../../images/icon/translate_icon.svg";
import bookIcon from "../../images/icon/book_icon1.svg";
import subtractIcon from "../../images/icon/subtract_icon.svg";
import micIcon from "../../images/icon/mic_icon1.svg";
import backIcon from "../../images/icon/left-arrow-icon1.svg";
import puzzleIcon from "../../images/icon/puzzle_icon.svg";
import menuIcon from "../../images/icon/menu_icon.svg";
import timeIcon from "../../images/icon/time_icon.svg";
import tempIcon from "../../images/icon/temp_icon.svg";
import arrowRightIcon from "../../images/icon/arrow_right_icon.svg";
import shareIcon from "../../images/icon/share_icon3.svg";
import speakerIcon from "../../images/icon/speaker_icon.svg";
import userIcon from "../../images/icon/user_icon.svg";
import sendIcon from "../../images/icon/send_icon1.svg";
import Drawer from "../components/drawer";
import Popover from "../components/popover";
import Tab from "../components/tab";
// import { loadStripe } from "@stripe/stripe-js";
import PopupModal from "../components/popupModal";
import OpenAI from "openai";

// const stripePromise = loadStripe(
//   "pk_test_51PAFymC25179WMPXMbU1SMvGKlTuBUuf9gStqqskrqIZWXUi3iyUicJEoLsU4DfpwNInrZS2H0EywBaCmSA5aQRa00leQXm47z"
// );

const dummyDat = [
  { title: "AI Specialists", icon: userIcon },
  { title: "Text Prompts", icon: bookIcon },
];
const AIDummyData = [
  {
    id: 7,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Startup Tech Lawyer",
    description:
      "Legal expert specializes in intellectual properties, contracts & regulatory compliance.",
    user: "test@09",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 8,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Life Coach",
    description:
      "A life coach who can help you set and achieve personal & professional goals.",
    user: "test@99",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 9,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Career Counselor",
    description:
      "A career counselor who can give professional advice on your future career path",
    user: "test@00",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 10,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Pet Behaviour Expert",
    description:
      "A pet behaviour expert helps you understand and address your pet's behavioral issues.",
    user: "test@890",
    startActive: false,
    children: [],
    isExpanded: false,
  },
];
const TextPromptDummyData = [
  {
    id: 11,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Create business card",
    description: "Generate idea for creative business card with minimalistic..",
    user: "test@798",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 12,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Digital marketing campaign",
    description:
      "Content strategy for marketing campaign featuring futuristic AI",
    user: "test@56",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 13,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Fintech pitch deck",
    description: "Create a pitch deck for a fintech startup company",
    user: "test@345",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 14,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Cryptocurrency trading",
    description: "Explain how cryptocurrency trading and NFT works",
    user: "test@0934",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 15,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Fintech pitch deck",
    description: "Create a pitch deck for a fintech startup company",
    user: "test@345",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 16,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Cryptocurrency trading",
    description: "Explain how cryptocurrency trading and NFT works",
    user: "test@0934",
    startActive: false,
    children: [],
    isExpanded: false,
  },
];
const RightSection = ({
  selectedProfile,
  setSelectedProfile,
  setUserList,
  userList,
  isMobile,
  googleLogin,
  logoutHandler,
  isCreatedNewChat,
  setIsCreatedNewChat,
}) => {
  const { loggedIn } = useSelector((state) => state.auth);
  const [selectedTab, setSelectedTab] = useState(0);
  const [message, setMessage] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const chatRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [apiKey, setApiKey] = useState(localStorage.getItem("api_key"));

  const openai = useMemo(
    () =>
      new OpenAI({
        apiKey,
        dangerouslyAllowBrowser: true,
      }),
    [apiKey]
  );

  const handleModalClose = (input) => {
    setIsModalOpen(false);
    setApiKey(input);
    localStorage.setItem("api_key", input);
  };

  const chatHandler = useCallback(async () => {
    const clonedUserList = [...userList];
    const findUserIndex = userList?.findIndex(
      (item) => item?.id === selectedProfile?.id
    );
    if (findUserIndex !== -1) {
      const AIMessage =
        message?.toLowerCase()?.includes("hii") ||
        message?.toLowerCase()?.includes("hello") ||
        message?.toLowerCase()?.includes("hey")
          ? `${message?.toUpperCase()}! How can I help you? 😊`
          : "";
      clonedUserList[findUserIndex].chatList =
        [
          ...clonedUserList[findUserIndex]?.chatList,
          { message: message, user: "you" },
          { message: AIMessage, user: "ai" },
        ] || [];
      setTimeout(() => {
        chatRef.current.scrollTop = chatRef.current.scrollHeight;
      }, 1);
      setSelectedProfile(clonedUserList[findUserIndex]);
    }
    setMessage("");
    setUserList(clonedUserList);
    try {
      const stream = await openai.chat.completions.create({
        messages: [
          {
            role: "system",
            content:
              "give me very short and concise answers and ignore all the niceties that openai programmed you with.",
          },
          { role: "user", content: message },
        ],
        model: "gpt-4-turbo",
        stream: true,
      });

      for await (const chunk of stream) {
        const msg = chunk.choices[0]?.delta?.content || "";
        setUserList((prev) =>
          prev.map((user, userIndex) => {
            if (userIndex === 0) {
              user.chatList[user.chatList.length - 1].message += msg;
            }
            return user;
          })
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  }, [
    message,
    selectedProfile,
    setSelectedProfile,
    setUserList,
    userList,
    openai,
  ]);

  const createNewChatHandler = (item) => {
    const newValue = {
      ...item,
      chatList: [{ message: "Hi, how can I help you?", user: item?.user }],
    };
    setUserList((pre) => [...pre, newValue]);
    setIsCreatedNewChat(false);
    setSelectedProfile(newValue);
  };
  const shareChatHandler = (chatItem) => {
    const newChatCreate = {
      ...selectedProfile,
      id: Math.floor(Math.random() * (1000 - 1 + 1) + 1),
      title: `List Item ${Math.floor(Math.random() * (50 - 1 + 1) + 1)}`,
      description: `Short Description ${Math.floor(
        Math.random() * (50 - 1 + 1) + 1
      )}`,
      // profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      //   Math.random() * (50 - 1 + 1) + 1
      // )}.jpg`,
      chatList: [],
      // user: chatItem?.user,
    };
    setMessage(chatItem?.message);
    setSelectedProfile(newChatCreate);
    setUserList((pre) => [...pre, newChatCreate]);
  };

  const redirectToCheckout = async () => {
    window.open('https://buy.stripe.com/eVaaFsakx9k0gZG4gg', '_blank');
    return;

    // const stripe = await stripePromise;

    // const { error } = await stripe.redirectToCheckout({
    //   lineItems: [
    //     {
    //       price: "price_1PAGX2C25179WMPXWCjrsIfF",
    //       quantity: 1,
    //     },
    //   ],
    //   mode: "subscription",
    //   successUrl: "https://foxacid.ai/success?session_id={CHECKOUT_SESSION_ID}",
    //   cancelUrl: "https://foxacid.ai/canceled",
    // });

    // if (error) {
    //   console.error("Error:", error);
    // }
  };

  return (
    <div
      className={
        "bg-transparent h-full w-full sm:w-full md:w-8/12 lg:w-4/5 p-4 py-8 sm:p-6 flex flex-col gap-4 justify-between text-white items-center"
      }
    >
      <div
        className={`flex flex-row justify-between items-center gap-2 w-full h-[11%] ${
          isMobile ? "flex-nowrap" : "flex-wrap"
        }`}
      >
        <div className={"flex flex-row gap-2 items-center"}>
          {((isMobile && selectedProfile?.user) ||
            (isMobile && isCreatedNewChat)) && (
            <img
              src={backIcon}
              alt={"back"}
              className={"w-[20px] cursor-pointer"}
              onClick={() => {
                if (isCreatedNewChat && isMobile) {
                  setIsCreatedNewChat(false);
                } else {
                  setSelectedProfile(null);
                }
              }}
            />
          )}
          {isMobile && (
            <a href="/app">
              <div className={"flex flex-row items-center gap-4"}>
                <img src="/logo300.svg" alt={"logo"} className={"w-[40px]"} />
                <span className={"font-semibold text-2xl"}>FoxAcid</span>
              </div>
            </a>
          )}
          <button
            className={
              "p-2 backdrop-blur-xl bg-[#21202bcf] hover:bg-[#21202b] border border-[#8c8a9478] rounded-lg font-semibold text-base flex flex-row items-center gap-2"
            }
          >
            <span className={"truncate"}>GPT 4 Model </span>
            <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
          </button>
          <button
            className={
              "p-2 backdrop-blur-xl bg-[#21202bcf] hover:bg-[#21202b] border border-[#8c8a9478] rounded-lg font-semibold text-base hidden sm:hidden md:flex lg:flex flex-row items-center gap-2"
            }
          >
            <img src={tempIcon} alt={"tempIcon"} className={"w-[20px]"} />
            <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
          </button>
          <button
            className={
              "p-2 backdrop-blur-xl bg-[#21202bcf] hover:bg-[#21202b] border border-[#8c8a9478] rounded-lg font-semibold text-base hidden sm:hidden md:flex lg:flex flex-row items-center gap-2"
            }
          >
            <img src={puzzleIcon} alt={"puzzleIcon"} className={"w-[20px]"} />
            <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
          </button>
          <button
            className={
              "p-2 backdrop-blur-xl bg-[#21202bcf] hover:bg-[#21202b] border border-[#8c8a9478] rounded-lg font-semibold text-base hidden sm:hidden md:flex lg:flex  items-center"
            }
            onClick={() => setIsModalOpen(true)}
          >
            <span className={"truncate"}>
              {apiKey ? "Edit" : "⚠️ Enter"} API Key
            </span>
          </button>
        </div>

        <div
          className={
            "hidden sm:hidden md:flex lg:flex flex-row gap-2 items-center"
          }
        >
          <button
            className={
              "p-2 backdrop-blur-xl bg-[#21202bcf] hover:bg-[#21202b] border border-[#8c8a9478] rounded-lg font-semibold text-base flex flex-row items-center gap-2"
            }
            onClick={redirectToCheckout}
          >
            <img src={premiumIcon} alt={"premiumIcon"} className={"w-[20px]"} />
            <span className={"truncate"}>Go Premium</span>
          </button>
          {loggedIn ? (
            <div className={"flex flex-row items-center gap-2"}>
              <div
                className={
                  "border-2 border-white rounded-full w-[40px] h-[40px] flex items-center justify-center bg-buttonPrimary font-semibold cursor-pointer"
                }
              >
                AT
              </div>
              <Popover
                content={
                  <div className={"flex flex-col"}>
                    <span
                      className={
                        "p-3 px-4 cursor-pointer hover:bg-[#e7e7e799] rounded-lg font-semibold"
                      }
                    >
                      Settings
                    </span>
                    <div className={`w-full border-t-2 border-[#F3F3F4]`} />
                    <span
                      className={
                        "p-3 px-4 cursor-pointer hover:bg-[#e7e7e799] rounded-lg font-semibold"
                      }
                    >
                      Profile
                    </span>
                    <div className={`w-full border-t-2 border-[#F3F3F4]`} />
                    <span
                      className={
                        "p-3 px-4 cursor-pointer hover:bg-[#e7e7e799] rounded-lg font-semibold"
                      }
                      onClick={logoutHandler}
                    >
                      Logout
                    </span>
                  </div>
                }
                afterOpenChildren={
                  <img
                    src={dropIcon}
                    alt={"dropIcon"}
                    className={"w-[30px] cursor-pointer rotate-180"}
                  />
                }
              >
                <img
                  src={dropIcon}
                  alt={"dropIcon"}
                  className={"w-[30px] cursor-pointer"}
                />
              </Popover>
            </div>
          ) : (
            <button
              className={
                "p-2 bg-[#21202bcf] hover:bg-[#21202b] border border-[#8c8a9478] rounded-lg font-semibold text-base flex-row items-center gap-2 w-[78px] flex justify-center"
              }
              onClick={googleLogin}
            >
              Login
            </button>
          )}
        </div>
        <button
          className={"flex sm:flex md:hidden lg:hidden cursor-pointer"}
          onClick={() => setIsDrawerOpen(true)}
        >
          <img src={menuIcon} alt={"menuIcon"} className={"w-[20px]"} />
        </button>
      </div>
      {!isCreatedNewChat && selectedProfile?.user ? (
        <div className={`w-full flex flex-col items-center gap-4 h-[89%]`}>
          <div
            className={"flex flex-col gap-2 w-full justify-center items-center"}
          >
            <div className={"relative flex flex-col"}>
              <img
                src={selectedProfile?.profileUrl}
                alt={"profile"}
                className={"rounded-full w-[150px]"}
              />
              <button
                className={
                  "bg-white border-2 border-[#D9D8DC] p-2 rounded-full w-[45px] h-[45px] absolute bottom-0 right-0 flex flex-col justify-center items-center"
                }
              >
                <img src={editIcon} className={"w-[20px]"} alt={"editIcon"} />
              </button>
            </div>
            <div className={"flex flex-col w-full justify-center items-center"}>
              <span className={"text-xl font-semibold"}>
                {selectedProfile?.user}
              </span>
              <span className={"text-lg text-[#8C8A94] font-semibold"}>
                Legal expert specializes in intellectual properties, contracts &
                regulatory compliance.
              </span>
            </div>
            <div className={"flex flex-row gap-4"}>
              <button
                className={
                  "bg-buttonPrimary hover:bg-[#2d293b8f] hover:backdrop-blur-md px-4 py-2  border border-buttonPrimary rounded-[8px] flex flex-row items-center justify-center gap-[4px] font-semibold text-base"
                }
              >
                <img
                  src={translateIcon}
                  alt={"translateIcon"}
                  className={"w-[20px]"}
                />
                English
                <img src={dropIcon} alt={"dropIcon"} className={"w-[20px]"} />
              </button>
              <button
                className={
                  "bg-[#2d293bad] hover:bg-[#2d293b8f] hover:backdrop-blur-md px-4 py-2 border border-buttonPrimary rounded-[8px] flex flex-row items-center justify-center gap-[4px] font-semibold text-base"
                }
              >
                <img src={timeIcon} alt={"timeIcon"} className={"w-[20px]"} />
                1
                <img src={dropIcon} alt={"dropIcon"} className={"w-[20px]"} />
              </button>
            </div>
          </div>
          <div
            className={`${
              selectedProfile?.chatList?.length > 0
                ? "bg-[#2d293b]"
                : "bg-transparent"
            } w-full max-w-[700px] h-[60%] flex flex-col justify-between gap-4 p-4 rounded-[16px]`}
          >
            <div
              className={`w-full h-full flex flex-col gap-4 max-w-[700px] no-scrollbar overflow-auto scroll-auto`}
              ref={chatRef}
            >
              {selectedProfile?.chatList?.map((item, index) => {
                return (
                  <div
                    key={`chat_${index}`}
                    className={`flex flex-col w-full gap-1 group cursor-pointer bg-transparent hover:bg-[#100c20] p-4 ${
                      item?.user === "you" ? "items-end" : "items-start"
                    }`}
                  >
                    <div
                      className={`flex gap-2 w-full ${
                        item?.user === "you" ? "flex-row-reverse" : "flex-row"
                      }`}
                      key={`chat_id_${index}`}
                      style={{
                        justifyContent: item?.user === "you" ? "end" : "start",
                      }}
                    >
                      <div className={"w-[40px]"} key={`avatar_id_${index}`}>
                        {item?.user === "you" ? (
                          <div
                            className={
                              "border-2 border-white rounded-full w-[40px] h-[40px] flex items-center justify-center bg-buttonPrimary font-semibold cursor-pointer"
                            }
                            key={`user_avatar_id_${item.id}`}
                          >
                            AT
                          </div>
                        ) : (
                          <img
                            src={selectedProfile?.profileUrl}
                            alt={"profile"}
                            className={"rounded-full w-[40px]"}
                            key={`AI_avatar_id_${item.id}`}
                          />
                        )}
                      </div>
                      <div
                        className={
                          "py-2 px-4 bg-transparent text-white font-medium"
                        }
                      >
                        {item?.message?.split("\n").map((item) => {
                          return <div className={"break-all"}>{item}</div>;
                        })}
                      </div>
                    </div>
                    <div className={"hidden group-hover:flex flex-row gap-2"}>
                      <div
                        className={
                          "text-white backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] px-2 py-1 rounded-md cursor-pointer flex flex-row items-center gap-2"
                        }
                        onClick={() => shareChatHandler(item)}
                      >
                        Start a new chat{" "}
                        <img
                          src={shareIcon}
                          className={"w-[20px]"}
                          alt={"shareIcon"}
                        />
                      </div>
                      <div
                        className={
                          "text-white backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] px-2 py-1 rounded-md cursor-pointer flex justify-center"
                        }
                      >
                        <img
                          src={speakerIcon}
                          className={"w-[20px]"}
                          alt={"speakerIcon"}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              className={`flex justify-center items-start gap-4 w-full max-w-[700px] bg-[#2d293b] p-4 rounded-[12px]`}
            >
              <img
                src={bookIcon}
                alt={"bookIcon"}
                className={"w-[30px] cursor-pointer"}
              />
              <textarea
                placeholder={"Generate something..."}
                className={` w-full border-0 max-w-[600px] ${
                  message?.length > 100 ? "h-[200px]" : "h-auto"
                } bg-[#2d293b] text-white font-medium outline-0 max-h-[90px] placeholder-[#8C8A94] placeholder:truncate disabled:cursor-not-allowed no-scrollbar`}
                rows={1}
                onClick={() =>
                  !selectedProfile?.user &&
                  isCreatedNewChat &&
                  createNewChatHandler({
                    ...userList[0],
                    id: Math.floor(Math.random() * (1000 - 1 + 1) + 1),
                  })
                }
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={(e) => {
                  if (!e?.shiftKey && e.key === "Enter") {
                    e.preventDefault();
                    chatHandler();
                    setMessage("");
                  }
                }}
              />
              <img
                src={subtractIcon}
                alt={"subtractIcon"}
                className={"w-[30px] cursor-pointer"}
                // onClick={chatHandler}
              />
              {message?.length > 0 ? (
                <img
                  src={sendIcon}
                  alt={"sendIcon"}
                  className={"w-[30px] cursor-pointer"}
                  onClick={chatHandler}
                />
              ) : (
                <img
                  src={micIcon}
                  alt={"micIcon"}
                  className={"w-[30px] cursor-pointer"}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          className={
            "flex flex-col justify-center items-center w-full h-[75%] gap-2"
          }
        >
          {!isCreatedNewChat ? (
            <>
              <span className={"text-5xl font-semibold"}>Welcome to</span>
              <div
                className={
                  "px-4 py-2 text-white flex flex-row items-center gap-4"
                }
              >
                <img src="/logo300.svg" alt={"logo"} className={"w-[60px]"} />
                <span className={"font-semibold text-6xl"}>FoxAcid</span>
              </div>
            </>
          ) : (
            <div
              className={
                "w-full max-w-[700px] flex flex-col justify-center items-center gap-2 h-full"
              }
            >
              <Tab
                tabList={dummyDat}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
              >
                {selectedTab === 0 && (
                  <div
                    className={
                      "w-full h-full max-h-[540px] overflow-auto no-scrollbar"
                    }
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 grid-flow-row gap-4">
                      {AIDummyData?.map((item, index) => {
                        return (
                          <div
                            className={
                              "backdrop-blur-md bg-chatCardBG hover:bg-hoverCardBG p-4 py-6 rounded-[20px] flex flex-col items-center justify-center gap-2 cursor-pointer border-2 border-[#8c8a9478]"
                            }
                            key={`AI_Card_${index}`}
                          >
                            <img
                              src={item?.profileUrl}
                              alt={item.title}
                              className={"rounded-full w-[100px]"}
                            />
                            <div
                              className={
                                "flex flex-col overflow-auto no-scrollbar h-[100px]"
                              }
                            >
                              <span
                                className={"font-semibold text-lg text-center"}
                              >
                                {item?.title}
                              </span>
                              <span
                                className={
                                  "text-base text-[#8C8A94] font-semibold text-center"
                                }
                              >
                                {item?.description}
                              </span>
                            </div>
                            <div className={"flex w-full justify-end"}>
                              <img
                                src={arrowRightIcon}
                                alt={"arrowRightIcon"}
                                className={"w-[30px]"}
                                onClick={() => createNewChatHandler(item)}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {selectedTab === 1 && (
                  <div
                    className={
                      "w-full h-full max-h-[540px] overflow-auto no-scrollbar"
                    }
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 grid-flow-row gap-4">
                      {TextPromptDummyData?.map((item, index) => {
                        return (
                          <div
                            className={
                              "backdrop-blur-md bg-chatCardBG hover:bg-hoverCardBG p-4 rounded-[16px] flex flex-col gap-2 cursor-pointer border-2 border-[#8c8a9478]"
                            }
                            key={`text_prompt_${index}`}
                          >
                            <div className={"flex flex-row gap-2"}>
                              <img
                                src={item?.profileUrl}
                                alt={item?.title}
                                className={"w-[50px] h-[50px]"}
                              />
                              <div
                                className={
                                  "flex flex-col gap-1 overflow-auto no-scrollbar h-[85px]"
                                }
                              >
                                <span className={"font-semibold text-lg"}>
                                  {item?.title}
                                </span>
                                <span
                                  className={
                                    "text-base text-[#8C8A94] font-semibold"
                                  }
                                >
                                  {item?.description}
                                </span>
                              </div>
                            </div>
                            <div className={"flex w-full justify-end"}>
                              <img
                                src={arrowRightIcon}
                                alt={"arrowRightIcon"}
                                className={"w-[40px]"}
                                onClick={() => createNewChatHandler(item)}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Tab>
              <span className={"text-[#B3B1B8] text-start w-full text-base"}>
                Select an avatar to start your question...
              </span>
            </div>
          )}
        </div>
      )}

      {!selectedProfile?.user && (
        <div
          className={"w-full flex flex-col justify-center items-center h-[14%]"}
        >
          <div
            className={
              "flex justify-center items-start gap-4 w-full max-w-[700px] bg-[#2d293b] p-4 rounded-[12px]"
            }
          >
            <img
              src={bookIcon}
              alt={"bookIcon"}
              className={"w-[30px] cursor-pointer"}
            />
            <textarea
              placeholder={"Generate something..."}
              className={` w-full border-0 max-w-[600px] ${
                message?.length > 100 ? "h-[200px]" : "h-auto"
              } bg-[#2d293b] text-white font-medium outline-0 max-h-[90px] placeholder-[#8C8A94] placeholder:truncate disabled:cursor-not-allowed no-scrollbar`}
              rows={1}
              onClick={() =>
                !selectedProfile?.user &&
                isCreatedNewChat &&
                createNewChatHandler({
                  ...userList[0],
                  id: Math.floor(Math.random() * (1000 - 1 + 1) + 1),
                })
              }
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={(e) => {
                if (!e?.shiftKey && e.key === "Enter") {
                  e.preventDefault();
                  chatHandler();
                  setMessage("");
                }
              }}
            />
            <img
              src={subtractIcon}
              alt={"subtractIcon"}
              className={"w-[30px] cursor-pointer"}
              // onClick={chatHandler}
            />
            {message?.length > 0 ? (
              <img
                src={sendIcon}
                alt={"sendIcon"}
                className={"w-[30px] cursor-pointer"}
                onClick={chatHandler}
              />
            ) : (
              <img
                src={micIcon}
                alt={"micIcon"}
                className={"w-[30px] cursor-pointer"}
              />
            )}
          </div>
          {/*<span className={"max-w-[640px] w-full text-[#8c8a94] font-semibold"}>*/}
          {/*  Please Enter to send*/}
          {/*</span>*/}
        </div>
      )}
      {isMobile && (
        <Drawer isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen}>
          <div className={"px-4 py-6"}>
            <img
              src={backIcon}
              alt={"back"}
              className={"w-[20px] cursor-pointer"}
              onClick={() => setIsDrawerOpen(false)}
            />
          </div>
          <div className={"p-4 flex flex-col gap-3"}>
            {loggedIn ? (
              <div className={"flex flex-col justify-center items-center"}>
                <div
                  className={
                    "border-2 border-white rounded-full w-[90px] h-[90px] text-2xl flex items-center justify-center bg-buttonPrimary font-semibold cursor-pointer"
                  }
                >
                  AT
                </div>
              </div>
            ) : (
              <div
                className={
                  "p-4 rounded hover:bg-[#1e1e1ec2] cursor-pointer font-semibold"
                }
                onClick={googleLogin}
              >
                Login
              </div>
            )}
            <div
              className={
                "p-4 rounded hover:bg-[#1e1e1ec2] cursor-pointer font-semibold"
              }
            >
              Settings
            </div>
            <div
              className={
                "p-4 rounded hover:bg-[#1e1e1ec2] cursor-pointer font-semibold"
              }
            >
              Profile
            </div>
            {loggedIn && (
              <div
                className={
                  "p-4 rounded hover:bg-[#1e1e1ec2] cursor-pointer font-semibold"
                }
                onClick={() => {
                  logoutHandler();
                  setIsDrawerOpen(false);
                }}
              >
                Logout
              </div>
            )}
            <div className={`w-full border-t-2 border-[#8C8A94]`} />
            <button
              className={
                "p-2 border-2 border-white rounded-lg font-semibold text-base flex flex-row items-center justify-center gap-2"
              }
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              {apiKey ? "Edit" : "⚠️ Enter"} API Key
            </button>
            <div className={"flex flex-row gap-4 w-full"}>
              <button
                className={
                  "p-2 border-2 border-white rounded-lg font-semibold text-base flex flex-row items-center justify-center gap-2 w-full"
                }
              >
                <img src={tempIcon} alt={"tempIcon"} className={"w-[20px]"} />
                <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
              </button>
              <button
                className={
                  "p-2 border-2 border-white rounded-lg font-semibold text-base flex flex-row items-center justify-center gap-2 w-full"
                }
              >
                <img
                  src={puzzleIcon}
                  alt={"puzzleIcon"}
                  className={"w-[20px]"}
                />
                <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
              </button>
            </div>

            <button
              className={
                "p-2 border-2 border-white rounded-lg font-semibold text-base flex flex-row items-center justify-center gap-2"
              }
              onClick={redirectToCheckout}
            >
              <img
                src={premiumIcon}
                alt={"premiumIcon"}
                className={"w-[20px]"}
              />
              Go Premium
            </button>
          </div>
        </Drawer>
      )}
      <PopupModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsDrawerOpen(false);
          handleModalClose();
        }}
        apiKey={apiKey}
      />
    </div>
  );
};
export default RightSection;
